import { useApiRequest } from '@/lib/http-utils'
import { useQuery } from '@tanstack/react-query'
import { taskManagerApiPaths } from './_paths'

export enum DataAssetType {
  FOLDER = 'FOLDER',
  DOCUMENT = 'DOCUMENT',
  DATABASE = 'DATABASE',
  DATA = 'DATA',
}

export type DataAsset = {
  id: string
  domainId: string
  dataType: DataAssetType
  description: string | null
  shortDescription: string | null
  createdAt: string
  updatedAt: string
  owner: string | null
  createdBy: string | null
  name: string
  source: 'DATA_CATALOG' | 'CHAT' | 'EMERGENCE_TEAM'
  schemaName?: string
  tableNames?: string[]
}

type DataAssetsAPIResponse = {
  data: DataAsset[]
}

export function useDataAssetsQuery() {
  const { apiRequest, domainId } = useApiRequest()

  return useQuery<DataAssetsAPIResponse>({
    queryKey: ['data-assets', domainId],
    queryFn: async () => {
      const response = await apiRequest({
        path: taskManagerApiPaths.dataAssets({ domainId }),
      })

      if (!response.ok) {
        throw new Error('Error fetching data assets')
      }
      const json = (await response.json()) as DataAssetsAPIResponse

      return json
    },
  })
}
